import React from 'react';
import PropTypes from 'prop-types';

import 'login/components/Library/InformationZone/InformationZone.scss';

const InformationZoneElement = ({ image, title, subtitle }) => {
    return (
        <div className="element-information">
            <img src={image} alt={title} />
            <div className="element-information--text">
                <p className="element-information--text--title">{title}</p>
                <p className="element-information--text--subtitle">{subtitle}</p>
            </div>
        </div>
    );
};

InformationZoneElement.propTypes = {
    image: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string.isRequired,
};

InformationZoneElement.displayName = 'InformationZoneElement';

export default InformationZoneElement;
